<template>
    <b-modal
        centered
        v-model="visible"
        ref="changePasswordModal"
        id="changePasswordModal"
        :hide-footer="true"
        :hide-header="true"
        @hidden="onHidden"
    >
        <div class="modal-header">
            <div class="modal-title">
                <h5>{{$t('CHANGEPASSWORD')}}</h5>
            </div>
            <button type="button" aria-label="Close" @click="close" class="close">
                <img src="../../../../assets/img/icon-close.svg">
            </button>
        </div>
        <div class="d-block mt-2 modal-content-inside">
            <b-form-fieldset :label="$t('CURRENTPASSWORD')" class="full-input-group mb-3">
                <b-form-input
                    type="password"
                    v-model="currentPassword"
                    @keyup.enter="submit"
                ></b-form-input>
            </b-form-fieldset>

            <b-form-fieldset :label="$t('NEWPASSWORD')" class="full-input-group mb-3">
                <b-form-input
                    type="password"
                    v-model="newPassword"
                    @keyup.enter="submit"
                ></b-form-input>
            </b-form-fieldset>

            <b-form-fieldset :label="$t('REPEATNEWPASSWORD')" class="full-input-group mb-3">
                <b-form-input
                    type="password"
                    v-model="repeatNewPassword"
                    @keyup.enter="submit"
                ></b-form-input>
            </b-form-fieldset>

            <div class="password-requirements mb-3">
                <small class="text-muted">
                    <strong>{{$t('PASSWORDREQUIREMENTS')}}:</strong>
                    <ul class="mb-0 mt-1 pl-3">
                        <li>{{$t('PASSWORDREQ_LENGTH')}}</li>
                        <li>{{$t('PASSWORDREQ_LETTER')}}</li>
                        <li>{{$t('PASSWORDREQ_NUMBER')}}</li>
                        <li>{{$t('PASSWORDREQ_SPECIAL')}}</li>
                    </ul>
                </small>
            </div>

            <div v-if="validationError" class="alert alert-danger mb-3">
                {{ validationError }}
            </div>
        </div>
        <div class="text-center mb-lg">
            <b-btn class="mr-2 btn-bis btn-cancel" @click="close">{{$t('CANCEL')}}</b-btn>
            <b-btn class="btn-bis btn-primary" @click="submit" :disabled="loading">{{$t('SAVE')}}</b-btn>
        </div>
    </b-modal>
</template>

<script>
import axios from '@/lib/AxApi';

export default
{
    name: 'change-password-modal',
    props:
    {
        show:
        {
            type: Boolean,
            default: false,
        },
    },
    data()
    {
        return {
            currentPassword: '',
            newPassword: '',
            repeatNewPassword: '',
            validationError: '',
            loading: false,
        };
    },
    computed:
    {
        visible:
        {
            get()
            {
                return this.show;
            },
            set(val)
            {
                if (!val)
                {
                    this.$emit('close');
                }
            },
        },
    },
    methods:
    {
        close()
        {
            this.$emit('close');
        },
        onHidden()
        {
            this.resetForm();
        },
        resetForm()
        {
            this.currentPassword = '';
            this.newPassword = '';
            this.repeatNewPassword = '';
            this.validationError = '';
            this.loading = false;
        },
        validate()
        {
            if (this.newPassword !== this.repeatNewPassword)
            {
                this.validationError = this.$t('PASSWORDSDONOTMATCH');
                return false;
            }

            if (this.newPassword.length < 8)
            {
                this.validationError = this.$t('PASSWORDTOOSHORT');
                return false;
            }

            if (!/[a-zA-Z]/.test(this.newPassword))
            {
                this.validationError = this.$t('PASSWORDMISSINGLETTER');
                return false;
            }

            if (!/[0-9]/.test(this.newPassword))
            {
                this.validationError = this.$t('PASSWORDMISSINGNUMBER');
                return false;
            }

            if (!/[^a-zA-Z0-9]/.test(this.newPassword))
            {
                this.validationError = this.$t('PASSWORDMISSINGSPECIAL');
                return false;
            }

            this.validationError = '';
            return true;
        },
        async submit()
        {
            const me = this;

            if (!me.validate())
            {
                return;
            }

            me.loading = true;

            try
            {
                const response = await axios.post('/Session/changePassword', {
                    currentPassword: me.currentPassword,
                    newPassword: me.newPassword,
                    repeatNewPassword: me.repeatNewPassword,
                });

                const data = response.data;

                if (data.error)
                {
                    me.$notify.notice(data);
                }
                else
                {
                    me.$notify.notice({ error: false, notice: me.$t('PASSWORDCHANGEDSUCCESS') });
                    me.close();
                }
            }
            catch (e)
            {
                me.$notify.notice({ error: true, notice: 'GENERIC_ERROR' });
            }
            finally
            {
                me.loading = false;
            }
        },
    },
};
</script>
